import { Tooltip as ReactTooltip, type PlacesType } from 'react-tooltip';
import styles from './Tooltip.scss';

interface TooltipProps {
  children: React.ReactNode;
  anchorSelect: string;
  place?: PlacesType;
  hidden?: boolean;
}

const Tooltip = ({ children, anchorSelect, place = 'bottom', hidden = false }: TooltipProps) => (
  <ReactTooltip noArrow anchorSelect={anchorSelect} place={place} className={styles.tooltip} hidden={hidden}>
    {children}
  </ReactTooltip>
);

export default Tooltip;
